// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

import julius from "../assets/julius.jpg";



const SEO = ({
  title = "Coach Julius Adeleke - Professional Tennis Coach in the United State of America (US)",
  description = "Julius Adeleke, founder of Adeleke Tennis Academy, offers world-class tennis coaching for players of all levels in the United States.",
  keywords = "Tennis Coach, Julius Adeleke, Adeleke Tennis Academy, US tennis lessons, tennis training",
  url = "https://www.adeleketennisacademy.com",
  image = `${window.location.origin}${julius}`,
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Adeleke Tennis Academy (ATA)",
    "image": image,
    "description": description,
    "url": url,
    "telephone": "+18625764553",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "24949 Katy Ranch Road",
      "addressLocality": "Katy",
      "addressRegion": "Texas",
      "postalCode": "Tx 77494",
      "addressCountry": "US"
    },
    "founder": {
      "@type": "Person",
      "name": "Julius Adeleke",
      "jobTitle": "Tennis Coach",
      "url": url
    },
    "sport": "Tennis"
  };

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default SEO;
